import { render, staticRenderFns } from "./wulianKanban.vue?vue&type=template&id=1517e73c&scoped=true&"
import script from "./wulianKanban.vue?vue&type=script&lang=js&"
export * from "./wulianKanban.vue?vue&type=script&lang=js&"
import style0 from "./wulianKanban.vue?vue&type=style&index=0&id=1517e73c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1517e73c",
  null
  
)

export default component.exports